import React, { useContext } from "react";
import tour1 from "../photos/tsaxkadzorropeway.png";
import tour2 from "../photos/khorvirap.png";
import garnitemple from "../photos/Garnitemple.png";
import { WiTime4 } from "react-icons/wi";
import { GoArrowRight } from "react-icons/go";
import { NavLink } from "react-router-dom";
import "./hometours.css";
import { LanguageContext } from "../settings/LanguageContext";
import { booktour } from "../tours/tours"; // import the booktour array

const Hometours = () => {
  const { lang } = useContext(LanguageContext);

  // Translated static text
  const headings = {
    title: lang === "EN" ? "Popular Tours" : "Популярные туры",
    subtitle: lang === "EN"
      ? "Choose from our selection of carefully curated local experiences."
      : "Выберите из нашего тщательно подобранного выбора местных впечатлений.",
    more: lang === "EN" ? "More" : "Подробнее",
    viewMore: lang === "EN" ? "View More" : "Посмотреть все",
  };

  // find IDs dynamically from booktour
  const garniId = booktour.find(t => t.id === "garni")?.id;
  const tsaghId = booktour.find(t => t.id === "tsaghakadzorsevan")?.id;
  const khorId = booktour.find(t => t.id === "khorvirapnoravank")?.id;
  return (
    <div className="main2">
      <div className="main-popular">
        <h1 className="title-tours">{headings.title}</h1>
        <p className="text-2">{headings.subtitle}</p>

        <div className="tours-gallery">

          <NavLink to={`/tour/${garniId}`} className="NavGar">
            <div className="tour-gallery-point">
              <img src={garnitemple} alt="Garni Tour" />
              <div className="tour-text-book">
                <h2 className="tour-pack-title">
                  {lang === "EN" ? "Garni Geghard Symphony of Stones" : " Гарни Гегард Симфония камней"}
                </h2>
                <p className="tour-pack-text">
                  {lang === "EN"
                    ? "Discover ancient Armenia - Garni Temple, stunning Geghard Monastery carved in ..."
                    : "Откройте для себя древнюю Армению - храм Гарни, впечатляющий монастырь Гегард, вырезанный в ..."}
                </p>
                <div className="time-price">
                  <WiTime4 /> 6 {lang === "EN" ? "hours" : "часов"} - $70
                </div>
                <div className="book-now">
                  {headings.more}{" "}
                  <div className="arrow-btn">
                    <GoArrowRight className="arrow-icon" />
                  </div>
                </div>
              </div>
            </div>
          </NavLink>

          <NavLink to={`/tour/${tsaghId}`}>
            <div className="tour-gallery-point">
              <img src={tour1} alt="Yerevan City Tour" />
              <div className="tour-text-book">
                <h2 className="tour-pack-title">
                  {lang === "EN" ? "Tsaghakadzor Sevan" : "Цахкадзор Севан"}
                </h2>
                <p className="tour-pack-text">
                  {lang === "EN"
                    ? "Explore the Pink City - visit Cascade Complex, Republic Square, and discover..."
                    : "Исследуйте Розовый город — посетите Каскад, Площадь Республики и откройте для себя..."}
                </p>
                <div className="time-price">
                  <WiTime4 /> 7-8 {lang === "EN" ? "hours" : "часов"} - 100 USD
                </div>
                <div className="book-now">
                  {headings.more}{" "}
                  <div className="arrow-btn">
                    <GoArrowRight className="arrow-icon" />
                  </div>
                </div>
              </div>
            </div>
          </NavLink>

          <NavLink to={`/tour/${khorId}`}>
            <div className="tour-gallery-point">
              <img src={tour2} alt="Lake Sevan Tour" />
              <div className="tour-text-book">
                <h2 className="tour-pack-title">
                  {lang === "EN"
                    ? "Khor Virap Areni Noravank"
                    : "Хор Вирап  Арени  Нораванк"}
                </h2>
                <p className="tour-pack-text">
                  {lang === "EN"
                    ? "Embark on a captivating journey through Armenia’s history, culture, and stunning..."
                    : "Отправьтесь в увлекательное путешествие по истории, культуре и потрясающим…"}
                </p>
                <div className="time-price">
                  <WiTime4 /> 8-9 {lang === "EN" ? "hours" : "часов"} - 120 USD
                </div>
                <div className="book-now">
                  {headings.more}{" "}
                  <div className="arrow-btn">
                    <GoArrowRight className="arrow-icon" />
                  </div>
                </div>
              </div>
            </div>
          </NavLink>

        </div>

        <NavLink to="/tours" className={({ isActive }) => (isActive ? "active" : "")}>
          <div className="viewmore">
            <button className="btn-viewmore">{headings.viewMore}</button>
          </div>
        </NavLink>
      </div>
    </div>
  );
};

export default Hometours;
